import { render, staticRenderFns } from "./DetailsSqure.vue?vue&type=template&id=0900c625&scoped=true&"
import script from "./DetailsSqure.vue?vue&type=script&lang=js&"
export * from "./DetailsSqure.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSqure.vue?vue&type=style&index=0&id=0900c625&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0900c625",
  null
  
)

export default component.exports